export const FormatMoney = (value) => {
    return new Intl.NumberFormat().format(value);
};